import * as React from 'react'
import PropTypes from 'prop-types'
import { dataProps } from '@ds/react-utils'
import { useThemeStyles } from '../../../theming'
import { variant } from '../../../utilities'
import type { AvatarSize } from '../Avatar'
import styles from './styles'

const avatarSizes = [
  'xxlarge',
  'xlarge',
  'large',
  'medium',
  'small',
  'xsmall',
] as const

export interface AvatarBadgeProps {
  /**
   * The text to present to assistive devices in order to identify the AvatarBadge.
   */
  accessibilityText: string
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  /**
   * The size of the Avatar Badge.
   */
  size?: AvatarSize
}

export function AvatarBadge({
  accessibilityText,
  size,
  ...restProps
}: AvatarBadgeProps) {
  const sx = useThemeStyles(styles)

  const badgeStyles = [
    sx.default.badge,
    size && sx[variant('size', size)].badge,
  ]

  const badgeText = <span css={sx.hidden}>{accessibilityText}</span>

  return (
    <span {...dataProps(restProps)} css={badgeStyles}>
      {badgeText}
    </span>
  )
}

AvatarBadge.propTypes = {
  accessibilityText: PropTypes.string.isRequired,
  'data-.*': PropTypes.string,
  size: PropTypes.oneOf(avatarSizes),
}

AvatarBadge.displayName = 'Avatar.Badge'
